import dinBoldFont from 'assets/fonts/DIN-Bold.ttf';
import dinMediumFont from 'assets/fonts/DIN-Medium.ttf';
import dinRegularFont from 'assets/fonts/DIN-Regular.ttf';
import zizziLightFont from 'assets/fonts/zizzi-light-webfont.woff';
import zizziFont from 'assets/fonts/zizzi-webfont.woff';

/**
 * Requires CSS implementation in v5
 * @see https://mui.com/customization/typography/#self-hosted-fonts
 */
const zizziFonts = `
  @font-face {
    font-family: 'Din';
    src: url(${dinRegularFont}) format('truetype');
    font-weight: normal;
    font-style: normal;
  }
  
  @font-face {
    font-family: 'Din';
    src: url(${dinMediumFont}) format('truetype');
    font-weight: 600;
    font-style: normal;
  }

  @font-face {
    font-family: 'Din';
    src: url(${dinBoldFont}) format('truetype');
    font-weight: bold;
    font-style: normal;
  }

  @font-face {
    font-family: 'Zizzi';
    src: url(${zizziFont}) format('woff');
    font-weight: normal;
    font-style: normal;
  }

  @font-face {
    font-family: 'Zizzi';
    src: url(${zizziLightFont}) format('woff');
    font-weight: normal;
    font-style: light;
  }
`;

export default zizziFonts;
